<template>
  <IntlTelInput
      ref="inputRef"
      :value="inputValue"
      :input-props="inputProps"
      :options="options"
  />
</template>
<script setup>
import {computed} from "vue";
import {useFormControl, useFormControlParser} from "@/js/Elements/Form/FormControl.js";
import IntlTelInput from "intl-tel-input/vueWithUtils";
import "intl-tel-input/styles";
import FormControlProps from "@/js/Elements/Form/FormControlProps.js";
import axios from "axios";

const emit = defineEmits([]);
const props = defineProps({
  ...FormControlProps,
  countryCode: {
    type: String,
    default: 'auto'
  },
  countryCodeUrl: {
    type: String,
    default: 'https://ipinfo.io'
  },
})
const {
  error,
  inputValue
} = useFormControl(props, emit);
const { parsedPlaceholder, parsedName } = useFormControlParser(props);

const inputProps = computed(() => {
  return {
    name: parsedName.value,
    class: ['form-control', {
      'is-invalid': error,
      'form-control-sm': props.small,
      'disabled': props.disabled,
    }],
    disabled: props.disabled,
  }
});
const options = computed(() => {
  return {
    dropdownContainer: document.body,
    preferredCountries: [],
    initialCountry: props.countryCode,
    formatOnDisplay: true,
    nationalMode: false,
    separateDialCode: false,
    geoIpLookup(success) {
      if (inputValue.value) {
        success(null);
        return;
      }
      axios.get(props.countryCodeUrl, { ignoreRedirect: true }).then((response) => {
        const code = response.data?.country || 'us';
        success(code);
      });
    }
  };
});

function onReady() {
  console.log(arguments);
}
</script>
<style lang="scss">
@import "@/css/functions";
@import "@/css/variables";

.iti__selected-country {
  --iti-hover-color: #{themeColor('neutral-100')};
}

.iti--inline-dropdown .iti__dropdown-content {
  --iti-dialcode-color: #{themeColor('neutral-600')};
  --iti-icon-color: #{themeColor('neutral-500')};

  border-radius: $border-radius-xl;
  border: none;
  overflow: hidden;
  box-shadow: $soft-secondary-shadow;

  .iti__search-input-wrapper {
    display: flex;
    align-items: center;

    .iti__search-icon {
      width: toRem(14);
      margin-top: toRem(-1);
    }

    .iti__search-input {
      padding-top: spacing(2);
      padding-bottom: spacing(2);
      border-bottom: themeColor('border') solid toRem(1);
      font-size: fontSize(5);
      border-radius: 0;

      &::placeholder {
        color: themeColor('neutral-400');
      }

      &:focus {
        outline: none;
      }
    }
  }

  .iti__country-list {
    padding: spacing(2);
    min-height: toRem(280);

    .iti__country {
      border-radius: $border-radius-lg;
      padding: spacing(2);
      font-size: fontSize(5);
      font-weight: $font-weight-medium;

      &[aria-selected="true"] {
        background-color: themeColor('neutral-100');
        border: themeColor('primary') solid toRem(1);
      }

      &:hover,
      &.iti__highlight {
        &:not([aria-selected="true"]) {
          background-color: themeColor('neutral-100');
        }
      }

      .iti__country-check {
        display: none;
      }



      .iti__dial-code {
        font-size: fontSize(6);
      }
    }
  }
}

</style>